/*
 * Category Filter For filter List and FAQs List Blocks
 */
(function ($) {
	const $filterBtn = $(".js-cat-filter-btn");
	const $filterItem = $(".js-cat-filter-item");
	const activeClass = 'btn-secondary shadow-secondary';
	const inactiveClass = 'btn-light-alt shadow-sm';

	$filterBtn.click(function (e) {
		e.preventDefault();
		const filterCategory = $(this).attr("data-filter-target");

		// Reset all buttons to the inactive state
		$filterBtn.removeClass(activeClass).addClass(inactiveClass);

		// Activate the selected button
		$(this).removeClass(inactiveClass).addClass(activeClass);

		if (filterCategory === "all") {
			// Show all items
			$filterItem.css('opacity', '1').show();
		} else {
			// Hide all items with a fade-out effect
			$filterItem.css('opacity', '0');

			// Use a delay before showing the matching items with a fade-in effect
			setTimeout(function () {
				// Hide all items
				$filterItem.hide();

				// Show only the items with a matching data-filter-category attribute
				$filterItem.filter('[data-filter-category*="' + filterCategory + '"]').css('opacity', '1').show();
			}, 300); // Adjust the delay duration as needed (in milliseconds)
		}
	});
})(jQuery);
